import { useEffect } from 'react';
import { Environment, getEnvironment } from '../../../../common/src/environment.ts';
import { useUserAttributes } from '../../data/use_user_attributes.ts';

// Redirects non-internal users home. `allowInDev` opens the page on dev servers with no user signed
// in, which is what a phone hitting a fresh dev-tunnel origin looks like. Dev only on purpose: a
// per-PR preview is a public URL serving a copy of production data, so it gates on a signed-in
// internal user exactly as production does (GitHub issue #3412).
export const useInternalPage = ({ allowInDev = false }: { allowInDev?: boolean } = {}) => {
  const { isInternalUser } = useUserAttributes();
  useEffect(() => {
    if (allowInDev && getEnvironment() === Environment.Dev) {
      return;
    }
    if (!isInternalUser) {
      window.location.href = '/';
    }
  });
};
